// extracted by mini-css-extract-plugin
export default {"siteloader":"siteloader_siteloader__3OEyy","main":"siteloader_main__xnbTM","center":"siteloader_center__jXiws","middle":"siteloader_middle__aKCN0","top":"siteloader_top__mVZ+A"};